import { render, staticRenderFns } from "./nostartPromot.vue?vue&type=template&id=a1a60cbe&scoped=true&"
import script from "./nostartPromot.vue?vue&type=script&lang=js&"
export * from "./nostartPromot.vue?vue&type=script&lang=js&"
import style0 from "./nostartPromot.vue?vue&type=style&index=0&id=a1a60cbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a60cbe",
  null
  
)

export default component.exports